// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkArea__container___bxfZM {
    overflow: hidden;
    display: flex;
    flex: 1 0 0;
    flex-direction: column;

    width: 0;
}

.WorkArea__tabsWrapper___bRm1V {
    display: flex;
}

.WorkArea__menuWrapper___HGKbE {
    display: flex;
    flex: 0 0 4rem;
    margin-right: 1.2rem;
}

.WorkArea__filled___sSpLf {
    background: var(--color-bg-secondary);
}

.WorkArea__view___vjAzF {
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    min-height: 0;
}

.WorkArea__projectObjectsPlaceholder___De2Af {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    place-content: center;
}

.WorkArea__tabApp___YMt3W {
    display: none;
    min-height: 0;
}

.WorkArea__tabApp___YMt3W.WorkArea__active___kUe0P {
    display: unset;
    flex-grow: 1;
}

.WorkArea__tabAppCrossplot___bjvu4.WorkArea__active___kUe0P {
    display: flex;
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkAreas/WorkArea/WorkArea.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,sBAAsB;;IAEtB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".container {\n    overflow: hidden;\n    display: flex;\n    flex: 1 0 0;\n    flex-direction: column;\n\n    width: 0;\n}\n\n.tabsWrapper {\n    display: flex;\n}\n\n.menuWrapper {\n    display: flex;\n    flex: 0 0 4rem;\n    margin-right: 1.2rem;\n}\n\n.filled {\n    background: var(--color-bg-secondary);\n}\n\n.view {\n    display: flex;\n    flex-flow: column nowrap;\n    flex-grow: 1;\n    min-height: 0;\n}\n\n.projectObjectsPlaceholder {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    place-content: center;\n}\n\n.tabApp {\n    display: none;\n    min-height: 0;\n}\n\n.tabApp.active {\n    display: unset;\n    flex-grow: 1;\n}\n\n.tabAppCrossplot.active {\n    display: flex;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WorkArea__container___bxfZM`,
	"tabsWrapper": `WorkArea__tabsWrapper___bRm1V`,
	"menuWrapper": `WorkArea__menuWrapper___HGKbE`,
	"filled": `WorkArea__filled___sSpLf`,
	"view": `WorkArea__view___vjAzF`,
	"projectObjectsPlaceholder": `WorkArea__projectObjectsPlaceholder___De2Af`,
	"tabApp": `WorkArea__tabApp___YMt3W`,
	"active": `WorkArea__active___kUe0P`,
	"tabAppCrossplot": `WorkArea__tabAppCrossplot___bjvu4`
};
export default ___CSS_LOADER_EXPORT___;
